module.exports = __webpack_public_path__ + "img/MES1_Indice5.db9a4b2f.png";